<template>
    <overlay-modal ref="overlayModal" width="65%">
        <template v-slot:header>
            <div class="d-md-flex justify-content-between">
                <div>
                    <h6 class="text-uppercase text-primary mb-0">{{category}}</h6>
                    <h4 class="mb-0 cursive">{{name}}</h4>
                </div>
                <div v-if="!isTrasferimento">
                    <button v-if="!isSelected" :disabled="!modified" class="mt-2 mt-md-0 btn btn-primary nowrap" @click="onConfirm">
                        Aggiungi ad itinerario
                    </button>
                    <button v-else :disabled="!modified" class="mt-2 mt-md-0 btn btn-primary nowrap" @click="onConfirm">
                        Conferma modifiche
                    </button>
                </div>
                <div class="d-flex justify-content-between" v-else>
                    <button v-if="showAggiungiAndata" :disabled="value.isTrasferimentoFisso" class="mt-2 mt-md-0 btn btn-primary nowrap mx-1" @click="onAggiungiAndata" >+ andata</button>
                    <button :disabled="value.isTrasferimentoFisso" v-else class="mt-2 mt-md-0 btn btn-secondary mx-1" @click="onRemoveAndata" >
                        <img src="../../../../assets/images/svg/white/icone_cestino.svg" width="16px"/>
                        andata
                    </button>
                    <button v-if="showAggiungiRitorno" :disabled="value.isTrasferimentoFisso" class="mt-2 mt-md-0 btn btn-primary nowrap mx-1" @click="onAggiungiRitorno" >+ ritorno</button>
                    <button :disabled="value.isTrasferimentoFisso" v-else class="mt-2 mt-md-0 btn btn-secondary mx-1" @click="onRemoveRitorno" >
                        <img src="../../../../assets/images/svg/white/icone_cestino.svg" width="16px"/>
                        ritorno
                    </button>
                </div>
            </div>
        </template>
        <template>
            <div class="modal-service-detail">
                <div>
                    <big-carousel ref="carouselRef" v-if="images.length>0" :images="images" class="mb-3"/>
                    <tabs class="mb-3">
                        <tab title="Seleziona le date" v-if="!isTrasferimento && !value.isObbligatorio">
                            <div v-for="(item, index) in groups" :key="index" class="mb-3">
                                <h3>{{'Camera ' + (index+1)}}</h3>
                                <div class="d-flex mb-2">
                                    <img src="../../../../assets/images/svg/black/icone_passeggeri.svg" height="18px" class="mr-2"/>
                                    <span class="d-block">{{cameraTextFromIndex(index)}}</span>
                                </div>
                                <div class="row">
                                    <div v-for="(item, index2) in days" :key="index2" class="col-6 col-md-3">
                                        <div class="my-2">
                                            <button :class="classes(index, item.day)" @click="onChange(index, item.day)">
                                                {{longDateFormatter(item.day)}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </tab>
                        <tab title="Descrizione" @click="onSelectTabDescrizione">
                            <p class="text-justify" style="white-space: pre-line" v-html="description"></p>
                        </tab>
                        <!--
                        <tab title="Itinerario">
                            <div class="row mb-4" v-for="(item, index) in places" :key="index">
                                <div class="col-12 col-md-4 pr-md-4">
                                    <CustomGoogleMap class="mb-2" height="200px" :markers="[{title: item.name, lat: item.coordinate.latitude, lng: item.coordinate.longitude}]"/>
                                </div>
                                <div class="col-12 col-md-8">
                                    <div class="mb-2">
                                        <h6 class="mb-0">{{item.name}}</h6>
                                        <small>({{item.address}})</small>
                                    </div>
                                    <p class="text-justify">{{item.description}}</p>
                                </div>
                            </div>
                        </tab>
                        -->
                        <tab title="Note">
                            <table v-if="!isMobile" class="table table-striped">
                                <tbody>
                                <tr v-for="(item, index) in notes" :key="index">
                                    <td style="width:30%">
                                        <b>{{item.title}}</b>
                                    </td>
                                    <td style="width:70%">
                                        <p class="m-0" v-html="item.text"></p>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div v-else>
                                <div v-for="(item, index) in notes" :key="index">
                                    <b>{{item.title}}</b>
                                    <p class="mb-3 border-top pt-1" v-html="item.text"></p>
                                </div>
                            </div>
                        </tab>
                    </tabs>
                </div>
            </div>
        </template>
    </overlay-modal>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import OverlayModal from '../../../modals/OverlayModal'
import CustomGoogleMap from '../CustomGoogleMap'
import BigCarousel from '../BigCarousel'
import {longDateFormatter} from '../../../../utils/formatter'
import {isSameDate, clone, cameraText} from '../../../../utils/helper'
import AnalyticEvents from '../../../common/AnalyticEvents'
import MobileDetector from '../../../common/MobileDetector'

export default {
  name: 'ModalServiceDetail',
  mixins: [AnalyticEvents, MobileDetector],
  components: {BigCarousel, CustomGoogleMap, OverlayModal},
  props: {
    value: Object,
    isTrasferimento: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modified: false,
      groups: []
    }
  },
  computed: {
    days () {
      return this.getItinerario().days
    },
    info () {
      return this.value ? this.value : {}
    },
    anagrafica () {
      return this.info.anagrafica
    },
    detail () {
      return this.info.anagrafica ? this.info.anagrafica.detailResponse.detail : this.info.detail
    },
    description () {
      return this.detail ? this.detail.description : ''
    },
    category () {
      return this.detail ? this.detail.serviceType : ''
    },
    name () {
      return this.detail ? this.detail.name : ''
    },
    images () {
      return this.info.anagrafica ? this.info.anagrafica.detailResponse.detail.imagesUrl : []
    },
    notes () {
      return this.detail ? this.detail.noteService : []
    },
    places () {
      return this.detail ? this.detail.places : []
    },
    isSelected () {
      const list = this.isTrasferimento ? this.getTrasferimentiSelected() : this.getServiziSelected()
      return list.some(item => {
        return this.value.detail.productID === item.detail.productID
      })
    },
    showAggiungiAndata () {
      const andata = this.getItinerario().trasferimenti.andata
      return andata === null || andata.detail.productID !== this.value.detail.productID
    },
    showAggiungiRitorno () {
      const ritorno = this.getItinerario().trasferimenti.ritorno
      return ritorno === null || ritorno.detail.productID !== this.value.detail.productID
    }
  },
  methods: {
    ...mapGetters(['getSearch', 'getItinerario', 'getTrasferimentiSelected', 'getServiziSelected']),
    ...mapActions(['addReplaceServizio', 'removeSelectedServizio']),
    longDateFormatter,
    cameraTextFromIndex (index) {
      const camera = this.getSearch().camere[index]
      return cameraText(camera)
    },
    isSelectedDay (index, day) {
      return isSameDate(day, this.groups[index].dateSelected)
    },
    classes (index, day) {
      const isSelected = this.isSelectedDay(index, day)
      return `w-100 btn rounded-0 text-uppercase ${isSelected ? 'cursor-default btn-primary' : 'btn-outline-primary'}`
    },
    onChange (index, day) {
      if (!isSameDate(day, this.groups[index].dateSelected)) {
        this.groups[index].dateSelected = day
        this.groups[index].selected = true
      }
      this.modified = true
    },
    onConfirm () {
      this.$emit('change', this.groups)
      this.close()
    },
    onSelectTabDescrizione () {
      this.trackModaleAttivitaTabDescrizione()
    },
    open (groups = []) {
      this.groups = clone(groups)
      this.$nextTick(() => {
        this.$refs.overlayModal.open()
      })
    },
    close: function () {
      this.$refs.overlayModal.close()
    },
    onAggiungiAndata () {
      this.trackModaleListaTrasferimentiAA()
      this.dateSelected = this.days[0].day
      this.onAddTrasferimento(true)
    },
    onRemoveAndata () {
      this.dateSelected = this.days[0].day
      this.onRemoveTrasferimento(true)
    },
    onAggiungiRitorno () {
      this.trackModaleListaTrasferimentiRR()
      this.dateSelected = this.days[this.days.length - 1].day
      this.onAddTrasferimento(false)
    },
    onRemoveRitorno () {
      this.dateSelected = this.days[this.days.length - 1].day
      this.onRemoveTrasferimento(false)
    },
    onAddTrasferimento (isAndata) {
      const groups = clone(this.groups)
      groups.forEach(item => { item.dateSelected = item.selected ? this.dateSelected : null })
      const payload = {...this.value, isAndata, groups, isTrasferimento: this.isTrasferimento}
      this.addReplaceServizio(payload)
      this.$emit('select', payload)
    },
    onRemoveTrasferimento (isAndata) {
      const payload = {day: this.dateSelected, servizio: {...this.value, isAndata, isTrasferimento: this.isTrasferimento}}
      this.removeSelectedServizio(payload)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/modals/ModalServiceDetail.vue